import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The old `journeys` URL for the Segment source connector, which the integrations directory still
// links to. The page lives at `/workspaces/:workspaceId/integrations/segment_out`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/integrations/segment_out'),
});
